import api from '../config/apiConfig';
import { getDeviceInfo } from '../Utils/deviceUtils';

/**
 * MFA Service - Handles all MFA-related API calls
 * Following existing patterns from LoginService.js
 */

export const enrollMfa = async (token) => {
  const response = await api.post('/mfa/enroll', {}, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

export const confirmMfaEnrollment = async (token, verificationCode, transKey) => {
  // Get device info for "MFA once per day" feature
  const deviceInfo = getDeviceInfo();

  const payload = {
    code: verificationCode,
    transKey,
    ...deviceInfo, // Include deviceId, timezone, screenResolution, language
  };

  const response = await api.post('/mfa/enroll/confirm', payload, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

export const verifyMfaCode = async (token, verificationCode, transKey) => {
  // Get device info for "MFA once per day" feature
  const deviceInfo = getDeviceInfo();

  const response = await api.post('/mfa/verify', {
    code: verificationCode,
    transKey,
    ...deviceInfo, // Include deviceId, timezone, screenResolution, language
  }, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

export const getMfaStatus = async (token) => {
  const response = await api.get('/mfa/status', {
    headers: {
      Authorization: token,
    },
  });

  return response.data;
};

export const disableMfa = async (token) => {
  const response = await api.post('/mfa/disable', {}, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};
